import {
    FETCH_SERVICE_REQUEST,
    FETCH_SERVICE_SUCCESS,
    FETCH_SERVICE_FAILURE,
} from '../actions';

export const fetchServiceRequest = (serviceProvider) => ({
    type: FETCH_SERVICE_REQUEST,
    payload: serviceProvider,
});

export const fetchServiceSuccess = (featuresUrl) => ({
    type: FETCH_SERVICE_SUCCESS,
    payload: featuresUrl,
});

export const fetchServiceFailure = (error) => ({
    type: FETCH_SERVICE_FAILURE,
    payload: error,
});
